module.exports = __webpack_public_path__ + "img/characterAnime13.3d1dd919.png";